import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private _$currentLangCode: BehaviorSubject<string>;
  
  constructor(
    public http: HttpClient,
    private translateService: TranslateService,
  ) {
    this._$currentLangCode = new BehaviorSubject<string>(environment.defaultLangCode);
  }

  public initAppLanguage(defaultLangCode: string) {
    this.translateService.setDefaultLang(defaultLangCode);
  }
  public changeAppLanguage(langCode: string): Observable<any> {
    return this.translateService.use(langCode.toUpperCase());
  }
  public reloadTranslations(): void {
    this.translateService.reloadLang(this._$currentLangCode.getValue().toUpperCase());
  }
  public reloadTranslationsByCode(languageCode: string): void {
    this.translateService.reloadLang(languageCode.toUpperCase());
  }
  public getTranslationInTargetLanguage(key: string, language: string): Observable<any> {
    return this.translateService.getTranslation(language).pipe(map(translationObj => {
      return translationObj[key]
    }));

  }
  public getInstant(key: string): string {
    return this.translateService.instant(key);
  }
}
